import { useEffect, useState } from "react";
import { getCollectorMasters } from "../../services/collectorApi";
import {
  CollectorMastersCatalog,
  FALLBACK_MASTERS,
  normalizeMasters,
} from "../../helpers/collectorMasters";

export function useCollectorMasters() {
  const [masters, setMasters] = useState<CollectorMastersCatalog>(FALLBACK_MASTERS);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    getCollectorMasters()
      .then((res) => {
        if (cancelled) return;
        setMasters(normalizeMasters(res.data?.data || res.data));
      })
      .catch(() => {
        if (!cancelled) setMasters(FALLBACK_MASTERS);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return { masters, loading };
}
